import styled from "styled-components";

const OrdersWrap = styled.div`
  position: fixed;
  left: 8px;
  z-index: 1001;

  .Toastify__toast-container {
    
  }
`

const ArrowStyled = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const OrdersWindowStyled = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 300px;
  /* max-height: calc(100vh - 230px); */
  position: absolute;
  left: 0;
  top: 36px;
  border-radius: 16px;
  padding: 8px 24px 0 24px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 16px;
  z-index: 100001;

  .ordersBack {
    position: absolute;
    left: 8px;
    top: 0px;

    &:hover {
      cursor: pointer;
    }
  }

  .delay {
    width: 56px;
  }
`

const SpaceBetweenRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;

  .ordersInput {
    width: calc(60%);
  }

  p {
    display: flex;
    align-items: center;
  }

  ._input {
    width: 33%;
  }

  .is_in_coins {
    position: absolute;
    right: 8px;
    width: 2em;
    min-width: 2em;

    & > button > p {
      justify-content: end;
    }
  }

  .volume_input {
    width: 110px !important;

    input {
      padding-right: 2em !important;
    }
  }
`

const ToastMessageStyled = styled.div`
  width: 100%;
  position: relative;
  padding: 8px;
  border-radius: 8px;

  display: flex;
  flex-direction: column;

  h3 {
    width: 100%;
    text-align: center;
  }

`

const InputOutputRowStyled = styled.div`
  width: calc(100% + 48px);
  position: relative;
  display: flex;
  justify-content: center;
  gap: 0px;
`

const InputOutputBlockStyled = styled.div`
  width: 50%;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 0;
  border-bottom: none !important;

  p {
    white-space: nowrap
  }

  .input {
    width: 80px;
  }
`

export {
  OrdersWrap,
  ArrowStyled, 
  OrdersWindowStyled, 
  SpaceBetweenRow, 
  ToastMessageStyled,
  InputOutputRowStyled,
  InputOutputBlockStyled
}